<app-loader *ngIf="isLoading"></app-loader>
<div class="relative pt-0">
  <div class="mx-auto w-100 relative">
    <div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
      <div>
        <app-main-heading>
          <span title>{{ "SIDEBAR.MANAGEUSERS" | translate }}</span>
        </app-main-heading>
      </div>
      <div class="ms-auto">
        <div class="d-flex justify-content-center align-items-center">
          <div class="" *ngIf="loggedInUser?.roleType !== CommonEnum.MEMBERS">
            <div class="d-flex justify-content-center align-items-center">
              <button class="submit-btn bg-orgclr" (click)="openAddUser()">
                {{ "MANAGEUSER.ADDUSER" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ul class="nav nav-tabs bg-white reportTabs manage-navtabs">
      <li class="nav-item">
        <a (click)="openTabs('ACTIVEUSERS')" href="#tabs-activeuser" class="nav-link" [class.active]="openActiveUsers"
          id="tabs-activeuser-tab" data-bs-toggle="pill" data-bs-target="#tabs-activeuser" role="tab"
          aria-controls="tabs-activeuser" aria-selected="true">{{ "MANAGEUSER.ACTIVEUSERS" | translate }}
          <span>({{ activeUsersCount }})</span>
        </a>
      </li>
      <li class="nav-item" *ngIf="loggedInUser.roleType !== CommonEnum.MEMBERS">
        <a (click)="openTabs('SIGNUPPENDING')" href="#tabs-signuppending" class="nav-link"
          [class.active]="openSignUpPending" id="tabs-signuppending-tab" data-bs-toggle="pill"
          data-bs-target="#tabs-signuppending" role="tab" aria-controls="tabs-signuppending" aria-selected="false">{{
          "MANAGEUSER.SIGNUPPENDING" | translate }}
          <span> ({{ pendingUsersCount }}) </span>
        </a>
      </li>
    </ul>
  </div>
</div>

<div *ngIf="openActiveUsers" class="relative pt-2 pb-6" id="tabs-activeuser" role="tabpanel"
  aria-labelledby="tabs-activeuser-tab">
  <div class="mx-auto d-none d-md-block w-100 relative">
    <div class="tab-content" id="pills-tabContent">
      <div class="tab-pane fade show active" role="tabpanel" aria-labelledby="pills-home-tab" *ngIf="enableGridView">
        <!-- verticle  -->
        <div class="d-flex mt-3 mb-5">
          <div class="col-3">
            <nav id="">
              <div
                class="left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch px-0 d-flex flex-wrap align-items-center justify-content-between">
                <ul class="flex-column min-w-100 d-flex list-unstyled me-3" id="pills-tabVertical">
                  <li *ngFor="
                      let user of activeUsers;
                      let i = index;
                      trackBy: trackByFn
                    " (click)="getPerUserData(i, user)" [ngClass]="
                      selectedIndex == i ? 'q-vertical-text-user-selected':'q-vertical-text-user' "
                    class="align-items-center cursor-pointer bg-white">
                    <tab-title-inline>
                      <span title1>
                        <span><img *ngIf="user.roleTypeStr == 'Super Admin'" src="./assets/images/crownicon.png" alt=""
                            class="" style="width: 35px;height: 35px;" /></span>
                        <span><img *ngIf="user.roleTypeStr != 'Super Admin'" src="./assets/images/UserBlueBag.svg"
                            alt="" class="" style="width: 35px;height: 35px;" /></span>
                        <span data-toggle="tooltip" style="font-size: 16px;" title="{{user?.name}}">
                          {{ user?.name == null ? "" : user?.name.length > 20 ? user?.name.slice(0,20) + "..." :
                          user?.name }}
                        </span>
                        <div class="d-flex justify-content-between mt-2 me-3">
                          <span class="badge ms-2" data-toggle="tooltip" title="{{getRoleLabel(user?.roleTypeStr)}}"
                            [style.color]="privacyStatusClr" [style.background-color]="privacyStatusBg">
                            {{ getRoleLabel(user?.roleTypeStr) }}
                          </span>
                          <span data-toggle="tooltip" style="font-size: 14px; font-weight: 600;"
                            title="{{user?.deviceCount}}">
                            <span>{{ "MANAGEUSER.DEVICES" | translate }} :</span>
                            {{
                            user?.deviceCount == null ? "" : user?.deviceCount
                            }}</span>
                        </div>
                      </span>
                    </tab-title-inline>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
          <div class="col-9">
            <div *ngIf="!editMode" class="q-vertical-content-user">
              <ng-container *ngIf="selectedIndex === 0">
                <div class="pt-5 ms-4 mb-4">
                  <div class="row d-flex flex-wrap mb-4">
                    <div [ngClass]="selectedLanguage === 'ja' ?'col-3': 'col-2'">
                      <span class="q-tab-content-list-title">{{ "MANAGEUSER.NAME" | translate }}</span>
                    </div>
                    <div class="col-3">
                      <span class="q-tab-content-list-desc"> {{ getFirstIndexData?.name == null
                        ? " N/A"
                        : getFirstIndexData?.lastName == null ? getFirstIndexData.name : getFirstIndexData?.name + " " +
                        getFirstIndexData?.lastName
                        }}</span>
                      <span class="q-tab-content-list-desc"> </span>
                    </div>
                  </div>
                  <div class="row d-flex flex-wrap mb-4">
                    <div [ngClass]="selectedLanguage === 'ja' ?'col-3': 'col-2'">
                      <span class="q-tab-content-list-title">{{ "MANAGEUSER.ROLES" | translate }}</span>
                    </div>
                    <div class="col-3">
                      <span class="q-tab-content-list-desc"> {{
                        getFirstIndexData?.roleTypeStr == null
                        ? "N/A"
                        : (getFirstIndexData?.roleType | translate)
                        }}</span>
                      <span class="q-tab-content-list-desc"> </span>
                    </div>
                  </div>
                  <div class="row d-flex flex-wrap mb-4">
                    <div [ngClass]="selectedLanguage === 'ja' ?'col-3': 'col-2'">
                      <span class="q-tab-content-list-title">{{
                        "MANAGEUSER.PHONENUMBER" | translate }}</span>
                    </div>
                    <div class="col-3">
                      <span class="q-tab-content-list-desc">
                        {{ getFirstIndexData?.countryCode !=null ? getFirstIndexData?.countryCode : "+91"}} {{
                        getFirstIndexData?.mobileNo == null
                        ? ""
                        : getFirstIndexData?.mobileNo
                        }}
                        <span *ngIf="isPhoneNoVerified==true">
                          <img src="assets/images/success.svg" alt="" class="ms-1" />
                        </span>
                      </span>

                      <span class="q-tab-content-list-desc"> </span>
                    </div>
                  </div>
                  <div class="row d-flex flex-wrap mb-4">
                    <div [ngClass]="selectedLanguage === 'ja' ?'col-3': 'col-2'">
                      <span class="q-tab-content-list-title">
                        {{ "MANAGEUSER.EMAIL" | translate }}</span>
                    </div>
                    <div class="col-8">
                      <span class="q-tab-content-list-desc"> {{
                        getFirstIndexData?.email == null
                        ? "N/A"
                        : getFirstIndexData?.email
                        }} <span *ngIf="isEmailVerified && getFirstIndexData?.roleTypeStr=='Child'">
                          <img src="assets/images/success.svg" alt="" class="ms-1" />
                        </span></span>
                      <span class="q-tab-content-list-desc"> </span>
                    </div>
                  </div>
                  <div class="row d-flex flex-wrap mb-4">
                    <div [ngClass]="selectedLanguage === 'ja' ?'col-3': 'col-2'">
                      <span class="q-tab-content-list-title">
                        {{ "MANAGEUSER.AGE" | translate }}</span>
                    </div>
                    <div class="col-3">
                      <span class="q-tab-content-list-desc"> {{
                        getFirstIndexData?.age == null
                        ? "N/A"
                        : getFirstIndexData?.age
                        }}</span>
                      <span class="q-tab-content-list-desc"> </span>
                    </div>
                  </div>
                  <div class="row d-flex flex-wrap mb-4">
                    <div [ngClass]="selectedLanguage === 'ja' ?'col-3': 'col-2'">
                      <span class="q-tab-content-list-title">
                        {{ "MANAGEUSER.GENDER" | translate }}</span>
                    </div>
                    <div class="col-3">
                      <span class="q-tab-content-list-desc"> {{
                        getFirstIndexData?.genderType == null
                        ? "N/A"
                        : (getFirstIndexData?.gender|translate)
                        }}</span>
                      <span class="q-tab-content-list-desc"> </span>
                    </div>
                  </div>
                  <div class="row"><span><button class="submit-btn bg-orgclr me-3"
                        (click)="isNavigate('viewDevice', getFirstIndexData?.id)">
                        {{ "MANAGEUSER.VIEWDEVICE" | translate }}
                      </button></span></div>

                </div>
              </ng-container>
              <!-- <ng-container *ngIf="selectedIndex === 0">
              <tab-content class="ms-4">
                <span title1>{{ "MANAGEUSER.NAME" | translate }} : </span>
                <span desc1 class="text-capitalize">{{
                  getFirstIndexData?.name == null
                  ? " N/A"
                  : getFirstIndexData?.name
                  }}</span>
                <span desc1 class="text-capitalize">{{
                  getFirstIndexData?.lastName == null
                  ? ""
                  : " "+getFirstIndexData?.lastName
                  }}</span>
                <span title2>{{ "MANAGEUSER.ROLES" | translate }} : </span>
                <span desc2>{{
                  getFirstIndexData?.roleTypeStr == null
                  ? "N/A"
                  : getFirstIndexData?.roleTypeStr
                  }}</span>
                <span title3>{{ "MANAGEUSER.EMAIL" | translate }} : </span>
                <span desc3>{{
                  getFirstIndexData?.email == null
                  ? "N/A"
                  : getFirstIndexData?.email
                  }}</span>

                <span title4 *ngIf="getFirstIndexData?.roleType != 'CHILD'">{{ "MANAGEUSER.PHONENUMBER" | translate }} :
                </span>
                <span desc4 *ngIf="getFirstIndexData?.roleType != 'CHILD'">{{
                  getFirstIndexData?.mobileNo == null
                  ? ""
                  : getFirstIndexData?.mobileNo
                  }}</span>

                <span title5 *ngIf="getFirstIndexData?.roleType != 'CHILD'">{{ "MANAGEUSER.AGE" | translate }} : </span>
                <span desc5 *ngIf="getFirstIndexData?.roleType != 'CHILD'">{{
                  getFirstIndexData?.age == null
                  ? ""
                  : getFirstIndexData?.age
                  }}</span>
                <span title6 *ngIf="getFirstIndexData?.roleType != 'CHILD'">{{ "MANAGEUSER.GENDER" | translate }} :
                </span>
                <span desc6 *ngIf="getFirstIndexData?.roleType != 'CHILD'">{{
                  getFirstIndexData?.genderType == null
                  ? ""
                  : getFirstIndexData?.genderType
                  }}</span>
                <span btn1><button class="submit-btn bg-orgclr me-3"
                    (click)="isNavigate('viewDevice', getFirstIndexData?.id)">
                    {{ "MANAGEUSER.VIEWDEVICE" | translate }}
                  </button></span>
              </tab-content>
            </ng-container> -->
              <ng-container *ngIf="selectedIndex && getFirstIndexData">
                <div class="pt-5 ms-4">
                  <div class="row d-flex flex-wrap mb-4">
                    <div class="col-2">
                      <span class="q-tab-content-list-title">{{ "MANAGEUSER.NAME" | translate }}</span>
                    </div>
                    <div class="col-3">
                      <span class="q-tab-content-list-desc"> {{ getFirstIndexData?.name == null
                        ? " N/A"
                        : getFirstIndexData?.lastName == null ? getFirstIndexData?.name : getFirstIndexData?.name + " "
                        +
                        getFirstIndexData?.lastName
                        }}</span>
                      <span class="q-tab-content-list-desc"> </span>
                    </div>
                  </div>
                  <div class="row d-flex flex-wrap mb-4">
                    <div class="col-2">
                      <span class="q-tab-content-list-title">{{ "MANAGEUSER.ROLES" | translate }}</span>
                    </div>
                    <div class="col-3">
                      <span class="q-tab-content-list-desc"> {{
                        getFirstIndexData?.roleTypeStr == null
                        ? "N/A"
                        : (getFirstIndexData?.roleType | translate)
                        }}</span>
                      <span class="q-tab-content-list-desc"> </span>
                    </div>
                  </div>
                  <div class="row d-flex flex-wrap mb-4">
                    <div class="col-2">
                      <span class="q-tab-content-list-title">{{
                        "MANAGEUSER.PHONENUMBER" | translate }}</span>
                    </div>
                    <div class="col-3">
                      <span class="q-tab-content-list-desc"> {{ getFirstIndexData?.countryCode !=null ?
                        getFirstIndexData?.countryCode + " " : "+91" }}{{
                        getFirstIndexData?.mobileNo == null
                        ? ""
                        : getFirstIndexData?.mobileNo
                        }}
                        <span *ngIf="getFirstIndexData.mobileNoVerified">
                          <img src="assets/images/success.svg" alt="" class="ms-1" />
                        </span>
                      </span>
                      <span class="q-tab-content-list-desc"> </span>
                    </div>
                  </div>
                  <div class="row d-flex flex-wrap mb-4">
                    <div class="col-2">
                      <span class="q-tab-content-list-title">
                        {{ "MANAGEUSER.EMAIL" | translate }}</span>
                    </div>
                    <div class="col-8">
                      <span class="q-tab-content-list-desc"> {{
                        getFirstIndexData?.email == null
                        ? "N/A"
                        : getFirstIndexData?.email
                        }}
                        <span *ngIf="isEmailVerified && getFirstIndexData?.roleTypeStr=='Child'">
                          <img src="assets/images/success.svg" alt="" class="ms-1" />
                        </span>
                      </span>

                      <span class="q-tab-content-list-desc"> </span>
                    </div>
                  </div>
                  <div class="row d-flex flex-wrap mb-4">
                    <div class="col-2">
                      <span class="q-tab-content-list-title">
                        {{ "MANAGEUSER.AGE" | translate }}</span>
                    </div>
                    <div class="col-3">
                      <span class="q-tab-content-list-desc"> {{
                        getFirstIndexData?.age == null
                        ? "N/A"
                        : getFirstIndexData?.age
                        }}</span>
                      <span class="q-tab-content-list-desc"> </span>
                    </div>
                  </div>
                  <div class="row d-flex flex-wrap mb-4">
                    <div class="col-2">
                      <span class="q-tab-content-list-title">
                        {{ "MANAGEUSER.GENDER" | translate }}</span>
                    </div>
                    <div class="col-3">
                      <span class="q-tab-content-list-desc"> {{
                        getFirstIndexData?.genderType == null
                        ? "N/A"
                        : (getFirstIndexData?.gender|translate)
                        }}</span>
                      <span class="q-tab-content-list-desc"> </span>
                    </div>
                  </div>
                  <div class="row"><span><button class="submit-btn bg-orgclr me-3"
                        (click)="isNavigate('viewDevice', getFirstIndexData?.id)">
                        {{ "MANAGEUSER.VIEWDEVICE" | translate }}
                      </button></span></div>

                </div>
              </ng-container>
              <!-- <ng-container *ngIf="selectedIndex && getFirstIndexData">
              <tab-content>
                <span title1>{{ "MANAGEUSER.NAME" | translate }} : </span>
                <span desc1 class="text-capitalize">{{
                  getFirstIndexData?.name == null
                  ? "N/A"
                  : getFirstIndexData?.name
                  }}</span>
                <span desc1 class="text-capitalize">{{
                  getFirstIndexData?.lastName == null
                  ? ""
                  : " "+getFirstIndexData?.lastName
                  }}</span>
                <span title2>{{ "MANAGEUSER.ROLES" | translate }} : </span>
                <span desc2>{{
                  getFirstIndexData?.roleTypeStr == null
                  ? "N/A"
                  : getFirstIndexData?.roleTypeStr
                  }}</span>
                <span title3>{{ "MANAGEUSER.EMAIL" | translate }} : </span>
                <span desc3>{{
                  getFirstIndexData?.email == null
                  ? "N/A"
                  : getFirstIndexData?.email
                  }}</span>
                <span title4>{{ "MANAGEUSER.PHONENUMBER" | translate }} :
                </span>
                <span desc4>{{
                  getFirstIndexData?.mobileNo == null
                  ? ""
                  : getFirstIndexData?.mobileNo
                  }}</span>

                <span title5>{{ "MANAGEUSER.AGE" | translate }} : </span>
                <span desc5>{{
                  getFirstIndexData?.age == null
                  ? ""
                  : getFirstIndexData?.age
                  }}</span>
                <span title6>{{ "MANAGEUSER.GENDER" | translate }} :
                </span>
                <span desc6>{{
                  getFirstIndexData?.genderType == null
                  ? ""
                  : getFirstIndexData?.genderType
                  }}</span>
                <span btn1 *ngIf="getFirstIndexData?.assignedUserStatus !== 'Pending'"><button
                    class="submit-btn bg-orgclr me-3" (click)="isNavigate('viewDevice', getFirstIndexData?.id)">
                    {{ "MANAGEUSER.VIEWDEVICE" | translate }}
                  </button></span>
              </tab-content>
            </ng-container> -->

              <div style="position: absolute; top: 24px; right: 75px">
                <span class="cursor-pointer" (click)="enableEdit('editMode')"><img
                    [src]="'MANAGEDEVICE.PENIMG'|translate" alt="" class="ms-4" /></span>
                <span class="cursor-pointer" *ngIf="selectedIndex !=0"
                  (click)="checkUserBeforeDeleting(getFirstIndexData)"><img src="./assets/images/deleteUser.png" alt=""
                    class="ms-xl-4" /></span>
              </div>
            </div>
            <div *ngIf="editMode" class="q-vertical-content-user border-radius-6">
              <ng-container>
                <div class="ms-0">
                  <app-add-user class="w-100" [isupdateUser]="isupdateUser" [updateUser]="getFirstIndexData"
                    (removeChildEvent)="disableEdit()"></app-add-user>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="d-block d-md-none" *ngIf="enableGridView">
    <div class="accordion mb-5 mt-4 faq-accordion" id="accordionExample">
      <div *ngFor="
            let user of activeUsers ;
            let i = index
              " class="accordion-item bg-white mb-3">
        <div class="accordion-header mb-0" id="headingOne{{ i }}">
          <button class="accordion-button shadow-none collapsed relative p-3 bg-white border-0" type="button"
            data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ i }}" aria-expanded="false"
            attr.aria-controls="collapseOne{{ i }}" (click)="getPerUserData(i, user)">
            <span class="me-4">
              <tab-title>
                <span title1><img *ngIf="!user?.avatarUrl" src="./assets/images/avatar.png" alt=""
                    class="mx-auto" /></span>
                <span title2>
                  <img *ngIf="user?.avatarUrl" [src]="user?.avatarUrl" alt="" class="mx-auto" />
                </span>
                <span title3 data-toggle="tooltip" title="{{user?.name}}">
                  {{ user?.name == null ? "N/A" : user?.name }}</span>
                <span title4>
                  {{
                  getRoleLabel(user?.roleTypeStr) == null ? "N/A" : getRoleLabel(user?.roleTypeStr)
                  }}</span>
                <span title5>
                  <img src="../../../assets/images/phone.png" alt="" width="20" height="20" />
                  {{
                  user?.mobileNo == null ? "N/A" : user?.mobileNo
                  }}</span>

                <span title6 class="text-center " *ngIf="user?.assignedUserStatus == 'ASSIGNED_USER_STATUS_PENDING'">
                  <span data-toggle="tooltip" i18n-title
                    title='{{ "SIGNUP.TITLE" | translate }}{{ user?.assignedUserStatus | translate }}'>
                    <img src="assets/images/error.svg" alt="" width="15" />
                    {{ "SIGNUP.TITLE" | translate }}
                    {{ user?.assignedUserStatus | translate}}
                  </span>
                </span>
                <span btn1 *ngIf="user?.assignedUserStatus == 'ASSIGNED_USER_STATUS_PENDING'">
                  <a data-toggle="tooltip" i18n-title title='{{ "MANAGEUSER.RESHARELINK" | translate }}'
                    (click)="reshareLink(user)" class="signuptxt  cursor-pointer">
                    {{ "MANAGEUSER.RESHARELINK" | translate }}</a>
                </span>
              </tab-title>
            </span>
          </button>
        </div>
        <div id="collapse_{{ i }}" class="accordion-collapse collapse" attr.aria-labelledby="headingOne{{ i }}"
          data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <tab-content>
              <span title1>{{ "MANAGEUSER.NAME" | translate }} : </span>
              <span desc1 class="text-capitalize"><span>{{
                  getFirstIndexData?.name == null
                  ? ""
                  : getFirstIndexData?.name
                  }} </span>
                <span>
                  {{
                  getFirstIndexData?.lastName == null
                  ? ""
                  : getFirstIndexData?.lastName
                  }}
                </span>
              </span>
              <span title2>{{ "MANAGEUSER.ROLES" | translate }} : </span>
              <span desc2>{{
                getFirstIndexData?.roleTypeStr == null
                ? "N/A"
                : (getFirstIndexData?.roleType | translate)
                }}</span>
              <span title3>{{ "MANAGEUSER.EMAIL" | translate }} : </span>
              <span desc3>{{
                getFirstIndexData?.email == null
                ? "N/A"
                : getFirstIndexData?.email
                }}</span>
              <span title4 *ngIf="getFirstIndexData?.roleType != 'CHILD'">{{ "MANAGEUSER.PHONENUMBER" | translate }} :
              </span>
              <span desc4 *ngIf="getFirstIndexData?.roleType != 'CHILD'">
                {{
                getFirstIndexData?.countryCode !=null ?
                getFirstIndexData?.countryCode + " " : "+91" }}
                {{
                getFirstIndexData?.mobileNo == null
                ? "N/A"
                : getFirstIndexData?.mobileNo
                }}</span>

              <span title5 *ngIf="getFirstIndexData?.roleType != 'CHILD'">{{ "MANAGEUSER.AGE" | translate }} : </span>
              <span desc5 *ngIf="getFirstIndexData?.roleType != 'CHILD'">{{
                getFirstIndexData?.age == null
                ? "N/A"
                : getFirstIndexData?.age
                }}</span>
              <span title6 *ngIf="getFirstIndexData?.roleType != 'CHILD'">{{ "MANAGEUSER.GENDER" | translate }} :
              </span>
              <span desc6 *ngIf="getFirstIndexData?.roleType != 'CHILD'">{{
                getFirstIndexData?.genderType == null
                ? "N/A"
                : (getFirstIndexData?.gender|translate)
                }}</span>
            </tab-content>
            <div *ngIf="selectedIndex === 0">
              <span btn1><button class="submit-btn bg-orgclr mb-2 me-3"
                  (click)="isNavigate('viewDevice', getFirstIndexData?.id)">
                  {{ "MANAGEUSER.VIEWDEVICE" | translate }}
                </button></span>
              <span btn2><button class="q-form-white-submit mb-2 me-3" (click)="
                              isNavigateMyDeviceOrLicense(
                                'viewLicense',
                                getFirstIndexData?.id
                              )
                            ">
                  {{ "MANAGEUSER.VIEWLICENSE" | translate }}
                </button></span>
              <span btn3><button *ngIf="!loggedInUser" type="button" class="q-form-white-submit"
                  (click)="checkUserBeforeDeleting(getFirstIndexData)">
                  {{ "MANAGEUSER.DELETEUSER" | translate }}
                </button>
              </span>
            </div>
            <div *ngIf="selectedIndex && getFirstIndexData">
              <span btn1 *ngIf="getFirstIndexData?.assignedUserStatus !== 'ASSIGNED_USER_STATUS_PENDING'"><button
                  class="submit-btn bg-orgclr mb-2 me-3" (click)="isNavigate('viewDevice', getFirstIndexData?.id)">
                  {{ "MANAGEUSER.VIEWDEVICE" | translate }}
                </button></span>
              <span btn2 *ngIf="getFirstIndexData?.assignedUserStatus !== 'ASSIGNED_USER_STATUS_PENDING'"><button
                  class="q-form-white-submit mb-2 me-3" (click)="isNavigate('viewLicense', getFirstIndexData?.id)">
                  {{ "MANAGEUSER.VIEWLICENSE" | translate }}
                </button></span>
              <span btn3 *ngIf="getFirstIndexData?.assignedUserStatus !== 'ASSIGNED_USER_STATUS_PENDING'"><button
                  type="button" class="q-form-white-submit" (click)="checkUserBeforeDeleting(getFirstIndexData)">
                  {{ "MANAGEUSER.DELETEUSER" | translate }}
                </button></span>
              <span btn3 *ngIf="getFirstIndexData?.assignedUserStatus === 'ASSIGNED_USER_STATUS_PENDING'"><button
                  type="button" class="q-form-white-submit" (click)="openTempUserDeletePopup(getFirstIndexData)">
                  {{ "MANAGEUSER.DELETEUSER" | translate }}
                </button></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="openSignUpPending && pendingUsersCount === 0" class="relative pt-2 pb-6" id="tabs-signuppending"
  role="tabpanel" aria-labelledby="tabs-signuppending-tab">
  <div class="row bg-white mt-3 mb-5 p-3 justify-content-center text-center rounded-25">
    <div class="col-md-12">
      <div class="nodatafounddiv">
        <img [src]="'IMAGES.NORECORDFOUNDIMG'|translate" class="img-fluid" alt="" />
        <h1 class="mt-4">
          <app-main-heading>
            <span title>{{
              "MANAGEUSER.NOUSERFOUND" | translate
              }}</span>
          </app-main-heading>
        </h1>
      </div>
    </div>
  </div>
</div>
<div *ngIf="openSignUpPending && pendingUsersCount >0" class="relative pt-2 pb-6" id="tabs-signuppending"
  role="tabpanel" aria-labelledby="tabs-signuppending-tab">
  <div class="mx-auto d-none d-md-block w-100 relative">
    <div class="tab-content" id="pills-tabContent">
      <div class="tab-pane fade show active" role="tabpanel" aria-labelledby="pills-home-tab" *ngIf="enableGridView">
        <!-- verticle  -->
        <div class="d-flex mt-3 mb-5">
          <div class="col-3">
            <nav id="">
              <div
                class="left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch px-0 d-flex flex-wrap align-items-center justify-content-between">
                <ul class="flex-column min-w-100 d-flex list-unstyled me-3" id="pills-tabVertical">
                  <li *ngFor="
                      let user of pendingUsers;
                      let i = index;
                      trackBy: trackByFn
                    " (click)="getPerUserData(i, user)"
                    [ngClass]="selectedIndex == i ? 'q-vertical-text-user-selected':'q-vertical-text-user' "
                    class="align-items-center  cursor-pointer bg-white">
                    <tab-title-inline>
                      <span title1>
                        <span><img *ngIf="user.roleTypeStr != 'Super Admin'" src="./assets/images/UserBlueBag.svg"
                            alt="" class="" style="width: 35px;height: 35px;" /></span>
                        <span data-toggle="tooltip" style="font-size: 16px;" title="{{user?.name}}">
                          {{ user?.name == null ? "" : user?.name.length > 20 ? user?.name.slice(0,20) + "..." :
                          user?.name
                          }}
                        </span>
                        <div class="d-flex justify-content-between mt-2 me-3">
                          <span class="badge ms-2" data-toggle="tooltip" title="{{getRoleLabel(user?.roleTypeStr)}}"
                            [style.color]="privacyStatusClr" [style.background-color]="privacyStatusBg">{{
                            getRoleLabel(user?.roleTypeStr) == null ? "" : getRoleLabel(user?.roleTypeStr)
                            }}
                          </span>
                        </div>
                      </span>
                    </tab-title-inline>
                  </li>
                </ul>
              </div>
            </nav>
          </div>

          <div *ngIf="!editMode" class="q-vertical-content-user">
            <ng-container *ngIf="selectedIndex === 0 && pendingUsersCount!=0">
              <div class="mt-5 ms-4">
                <div class="row d-flex flex-wrap mb-4">
                  <div class="col-2">
                    <span class="q-tab-content-list-title">{{ "MANAGEUSER.NAME" | translate }}</span>
                  </div>
                  <div class="col-3">
                    <span class="q-tab-content-list-desc"> {{ getFirstIndexData?.name == null
                      ? " N/A"
                      : getFirstIndexData?.lastName == null ? getFirstIndexData?.name : getFirstIndexData?.name + " " +
                      getFirstIndexData?.lastName
                      }}</span>
                    <span class="q-tab-content-list-desc"> </span>
                  </div>
                </div>
                <div class="row d-flex flex-wrap mb-4">
                  <div class="col-2">
                    <span class="q-tab-content-list-title">{{ "MANAGEUSER.ROLES" | translate }}</span>
                  </div>
                  <div class="col-3">
                    <span class="q-tab-content-list-desc"> {{
                      getFirstIndexData?.roleTypeStr == null
                      ? "N/A"
                      : (getFirstIndexData?.roleType | translate)
                      }}</span>
                    <span class="q-tab-content-list-desc"> </span>
                  </div>
                </div>
                <div class="row d-flex flex-wrap mb-4">
                  <div class="col-2">
                    <span class="q-tab-content-list-title" *ngIf="getFirstIndexData?.roleType != 'CHILD'">{{
                      "MANAGEUSER.PHONENUMBER" | translate }}</span>
                  </div>
                  <div class="col-3">
                    <span class="q-tab-content-list-desc" *ngIf="getFirstIndexData?.roleType != 'CHILD'">{{
                      getFirstIndexData?.countryCode !=null ?
                      getFirstIndexData?.countryCode + " " : "+91" }} {{
                      getFirstIndexData?.mobileNo == null
                      ? ""
                      : getFirstIndexData?.mobileNo
                      }}
                      <span *ngIf="getFirstIndexData.mobileNoVerified">
                        <img src="assets/images/success.svg" alt="" class="ms-1" />
                      </span>
                    </span>
                    <span class="q-tab-content-list-desc"> </span>
                  </div>
                </div>
                <div class="row d-flex flex-wrap mb-4">
                  <div class="col-2">
                    <span class="q-tab-content-list-title">
                      {{ "MANAGEUSER.EMAIL" | translate }}</span>
                  </div>
                  <div class="col-3">
                    <span class="q-tab-content-list-desc"> {{
                      getFirstIndexData?.email == null
                      ? "N/A"
                      : getFirstIndexData?.email
                      }}</span>
                    <span class="q-tab-content-list-desc"> </span>
                  </div>
                </div>
                <div class="row d-flex flex-wrap mb-4">
                  <div class="col-2">
                    <span class="q-tab-content-list-title">
                      {{ "MANAGEUSER.AGE" | translate }}</span>
                  </div>
                  <div class="col-3">
                    <span class="q-tab-content-list-desc"> {{
                      getFirstIndexData?.age == null
                      ? "N/A"
                      : getFirstIndexData?.age
                      }}</span>
                    <span class="q-tab-content-list-desc"> </span>
                  </div>
                </div>
                <div class="row d-flex flex-wrap mb-4">
                  <div class="col-2">
                    <span class="q-tab-content-list-title">
                      {{ "MANAGEUSER.GENDER" | translate }}</span>
                  </div>
                  <div class="col-3">
                    <span class="q-tab-content-list-desc"> {{
                      getFirstIndexData?.genderType == null
                      ? "N/A"
                      : (getFirstIndexData?.gender|translate)
                      }}</span>
                    <span class="q-tab-content-list-desc"> </span>
                  </div>
                </div>
                <div class="row"><span
                    *ngIf="getFirstIndexData?.assignedUserStatus == 'ASSIGNED_USER_STATUS_PENDING'"><button
                      class="submit-btn bg-orgclr me-3" (click)="reshareLink(getFirstIndexData)">
                      {{ "MANAGEUSER.RESHARELINK" | translate }}
                    </button></span></div>

              </div>
            </ng-container>
            <!-- <ng-container *ngIf="selectedIndex === 0 && pendingUsersCount!=0">
              <tab-content>
                <span title1>{{ "MANAGEUSER.NAME" | translate }} : </span>
                <span desc1 class="text-capitalize">{{
                  getFirstIndexData?.name == null
                  ? "NA"
                  : getFirstIndexData?.name
                  }}</span>
                <span desc1 class="text-capitalize">{{
                  getFirstIndexData?.lastName == null
                  ? ""
                  : " "+getFirstIndexData?.lastName
                  }}</span>
                <span title2>{{ "MANAGEUSER.ROLES" | translate }} : </span>
                <span desc2>{{
                  getFirstIndexData?.roleTypeStr == null
                  ? "N/A"
                  : getFirstIndexData?.roleTypeStr
                  }}</span>
                <span title3>{{ "MANAGEUSER.EMAIL" | translate }} : </span>
                <span desc3>{{
                  getFirstIndexData?.email == null
                  ? "N/A"
                  : getFirstIndexData?.email
                  }}</span>

                <span title4 *ngIf="getFirstIndexData?.roleType != 'CHILD'">{{ "MANAGEUSER.PHONENUMBER" | translate }} :
                </span>
                <span desc4 *ngIf="getFirstIndexData?.roleType != 'CHILD'">{{
                  getFirstIndexData?.mobileNo == null
                  ? ""
                  : getFirstIndexData?.mobileNo
                  }}</span>

                <span title5 *ngIf="getFirstIndexData?.roleType != 'CHILD'">{{ "MANAGEUSER.AGE" | translate }} : </span>
                <span desc5 *ngIf="getFirstIndexData?.roleType != 'CHILD'">{{
                  getFirstIndexData?.age == null
                  ? ""
                  : getFirstIndexData?.age
                  }}</span>
                <span title6 *ngIf="getFirstIndexData?.roleType != 'CHILD'">{{ "MANAGEUSER.GENDER" | translate }} :
                </span>
                <span desc6 *ngIf="getFirstIndexData?.roleType != 'CHILD'">{{
                  getFirstIndexData?.genderType == null
                  ? ""
                  : getFirstIndexData?.genderType
                  }}</span>
                <span btn1 *ngIf="getFirstIndexData?.assignedUserStatus == 'Pending'"><button
                    class="submit-btn bg-orgclr me-3" (click)="reshareLink(getFirstIndexData)">
                    {{ "MANAGEUSER.RESHARELINK" | translate }}
                  </button></span>
              </tab-content>
            </ng-container> -->
            <ng-container *ngIf="selectedIndex && getFirstIndexData">
              <div class="mt-5 ms-4">
                <div class="row d-flex flex-wrap mb-4">
                  <div class="col-2">
                    <span class="q-tab-content-list-title">{{ "MANAGEUSER.NAME" | translate }}</span>
                  </div>
                  <div class="col-3">
                    <span class="q-tab-content-list-desc"> {{ getFirstIndexData?.name == null
                      ? " N/A"
                      : getFirstIndexData?.lastName == null ? getFirstIndexData?.name : getFirstIndexData?.name + " " +
                      getFirstIndexData?.lastName
                      }}</span>
                    <span class="q-tab-content-list-desc"> </span>
                  </div>
                </div>
                <div class="row d-flex flex-wrap mb-4">
                  <div class="col-2">
                    <span class="q-tab-content-list-title">{{ "MANAGEUSER.ROLES" | translate }}</span>
                  </div>
                  <div class="col-3">
                    <span class="q-tab-content-list-desc"> {{
                      getFirstIndexData?.roleTypeStr == null
                      ? "N/A"
                      : (getFirstIndexData?.roleType | translate)
                      }}</span>
                    <span class="q-tab-content-list-desc"> </span>
                  </div>
                </div>
                <div class="row d-flex flex-wrap mb-4">
                  <div class="col-2">
                    <span class="q-tab-content-list-title" *ngIf="getFirstIndexData?.roleType != 'CHILD'">{{
                      "MANAGEUSER.PHONENUMBER" | translate }}</span>
                  </div>
                  <div class="col-3">
                    <span class="q-tab-content-list-desc" *ngIf="getFirstIndexData?.roleType != 'CHILD'">{{
                      getFirstIndexData?.countryCode !=null ?
                      getFirstIndexData?.countryCode + " " : "+91" }} {{
                      getFirstIndexData?.mobileNo == null
                      ? ""
                      : getFirstIndexData?.mobileNo
                      }}
                      <span *ngIf="getFirstIndexData.mobileNoVerified">
                        <img src="assets/images/success.svg" alt="" class="ms-1" />
                      </span>
                    </span>
                    <span class="q-tab-content-list-desc"> </span>
                  </div>
                </div>
                <div class="row d-flex flex-wrap mb-4">
                  <div class="col-2">
                    <span class="q-tab-content-list-title">
                      {{ "MANAGEUSER.EMAIL" | translate }}</span>
                  </div>
                  <div class="col-3">
                    <span class="q-tab-content-list-desc"> {{
                      getFirstIndexData?.email == null
                      ? "N/A"
                      : getFirstIndexData?.email
                      }}</span>
                    <span class="q-tab-content-list-desc"> </span>
                  </div>
                </div>
                <div class="row d-flex flex-wrap mb-4">
                  <div class="col-2">
                    <span class="q-tab-content-list-title">
                      {{ "MANAGEUSER.AGE" | translate }}</span>
                  </div>
                  <div class="col-3">
                    <span class="q-tab-content-list-desc"> {{
                      getFirstIndexData?.age == null
                      ? "N/A"
                      : getFirstIndexData?.age
                      }}</span>
                    <span class="q-tab-content-list-desc"> </span>
                  </div>
                </div>
                <div class="row d-flex flex-wrap mb-4">
                  <div class="col-2">
                    <span class="q-tab-content-list-title">
                      {{ "MANAGEUSER.GENDER" | translate }}</span>
                  </div>
                  <div class="col-3">
                    <span class="q-tab-content-list-desc"> {{
                      getFirstIndexData?.genderType == null
                      ? "N/A"
                      : (getFirstIndexData?.gender|translate)
                      }}</span>
                    <span class="q-tab-content-list-desc"> </span>
                  </div>
                </div>
                <div class="row"><span
                    *ngIf="getFirstIndexData?.assignedUserStatus == 'ASSIGNED_USER_STATUS_PENDING'"><button
                      class="submit-btn bg-orgclr me-3" (click)="reshareLink(getFirstIndexData)">
                      {{ "MANAGEUSER.RESHARELINK" | translate }}
                    </button></span></div>

              </div>
            </ng-container>

            <div *ngIf="pendingUsersCount!=0" style="position: absolute; top: 24px; right: 75px">
              <span class="cursor-pointer" (click)="enableEdit('editMode')"><img [src]="'MANAGEDEVICE.PENIMG'|translate"
                  alt="" class="ms-4" /></span>
              <span class="cursor-pointer"
                *ngIf="getFirstIndexData?.assignedUserStatus === 'ASSIGNED_USER_STATUS_PENDING'"
                (click)="openTempUserDeletePopup(getFirstIndexData)"><img src="./assets/images/deleteUser.png" alt=""
                  class="ms-xl-4" /></span>
            </div>

          </div>
          <div *ngIf="editMode" class="q-vertical-content-user" [ngClass]="
              selectedIndex === 0
                ? 'content-border-radius'
                : 'rounded-border-radius'
            ">
            <ng-container>
              <app-add-user [isupdateUser]="isupdateUser" [updateUser]="getFirstIndexData"
                (removeChildEvent)="disableEdit()"></app-add-user>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="d-block d-md-none" *ngIf="enableGridView">
    <div class="accordion mb-5 mt-4 faq-accordion" id="accordionExample">
      <div *ngFor="
            let user of pendingUsers;
            let i = index
              " class="accordion-item bg-white mb-3">
        <div class="accordion-header mb-0" id="headingOne{{ i }}">
          <button class="accordion-button shadow-none collapsed relative p-3 bg-white border-0" type="button"
            data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ i }}" aria-expanded="false"
            attr.aria-controls="collapseOne{{ i }}" (click)="getPerUserData(i, user)">
            <span class="me-4">
              <tab-title>
                <span title1><img *ngIf="!user?.avatarUrl" src="./assets/images/avatar.png" alt=""
                    class="mx-auto" /></span>
                <span title3 data-toggle="tooltip" title="{{user?.name}}">
                  {{ user?.name == null ? "N/A" : user?.name }}</span>
                <span title4>
                  {{
                  getRoleLabel(user?.roleTypeStr) == null ? "N/A" : getRoleLabel(user?.roleTypeStr)
                  }}</span>
                <span title5>
                  <img src="../../../assets/images/phone.png" alt="" width="20" height="20" />
                  {{
                  user?.mobileNo == null ? "N/A" : user?.mobileNo
                  }}</span>

                <span title6 class="text-center " *ngIf="user?.assignedUserStatus == 'ASSIGNED_USER_STATUS_PENDING'">
                  <span data-toggle="tooltip" i18n-title
                    title='{{ "SIGNUP.TITLE" | translate }}{{ user?.assignedUserStatus | translate }}'>
                    <img src="assets/images/error.svg" alt="" width="15" />
                    {{ "SIGNUP.TITLE" | translate }}
                    {{ user?.assignedUserStatus | translate }}
                  </span>
                </span>
                <span btn1 *ngIf="user?.assignedUserStatus == 'ASSIGNED_USER_STATUS_PENDING'">
                  <a data-toggle="tooltip" i18n-title title='{{ "MANAGEUSER.RESHARELINK" | translate }}'
                    (click)="reshareLink(user)" class="signuptxt  cursor-pointer">
                    {{ "MANAGEUSER.RESHARELINK" | translate }}</a>
                </span>
              </tab-title>
            </span>
          </button>
        </div>
        <div id="collapse_{{ i }}" class="accordion-collapse collapse" attr.aria-labelledby="headingOne{{ i }}"
          data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <tab-content>
              <span title1>{{ "MANAGEUSER.NAME" | translate }} : </span>
              <span desc1 class="text-capitalize">
                <span>{{
                  getFirstIndexData?.name == null
                  ? ""
                  : getFirstIndexData?.name
                  }}</span><span>&nbsp;</span>
                <span>{{
                  getFirstIndexData?.lastName == null
                  ? " N/A"
                  : getFirstIndexData?.lastName
                  }}</span>
              </span>
              <span title2>{{ "MANAGEUSER.ROLES" | translate }} : </span>
              <span desc2>{{
                getFirstIndexData?.roleTypeStr == null
                ? "N/A"
                : (getFirstIndexData?.roleType | translate)
                }}</span>
              <span title3>{{ "MANAGEUSER.EMAIL" | translate }} : </span>
              <span desc3>{{
                getFirstIndexData?.email == null
                ? "N/A"
                : getFirstIndexData?.email
                }}</span>
              <span title4 *ngIf="getFirstIndexData?.roleType != 'CHILD'">{{ "MANAGEUSER.PHONENUMBER" | translate }} :
              </span>
              <span desc4 *ngIf="getFirstIndexData?.roleType != 'CHILD'">
                {{
                getFirstIndexData?.countryCode !=null ?
                getFirstIndexData?.countryCode + " " : "+91" }}
                {{
                getFirstIndexData?.mobileNo == null
                ? "N/A"
                : getFirstIndexData?.mobileNo
                }}
              </span>

              <span title5 *ngIf="getFirstIndexData?.roleType != 'CHILD'">{{ "MANAGEUSER.AGE" | translate }} : </span>
              <span desc5 *ngIf="getFirstIndexData?.roleType != 'CHILD'">{{
                getFirstIndexData?.age == null
                ? "N/A"
                : getFirstIndexData?.age
                }}</span>
              <span title6 *ngIf="getFirstIndexData?.roleType != 'CHILD'">{{ "MANAGEUSER.GENDER" | translate }} :
              </span>
              <span desc6 *ngIf="getFirstIndexData?.roleType != 'CHILD'">{{
                getFirstIndexData?.genderType == null
                ? "N/A"
                :(getFirstIndexData?.gender|translate)
                }}</span>
            </tab-content>
            <div *ngIf="selectedIndex === 0">
              <span btn1><button class="submit-btn bg-orgclr mb-2 me-3"
                  (click)="isNavigate('viewDevice', getFirstIndexData?.id)">
                  {{ "MANAGEUSER.VIEWDEVICE" | translate }}
                </button></span>
              <span btn2><button class="q-form-white-submit mb-2 me-3" (click)="
                              isNavigateMyDeviceOrLicense(
                                'viewLicense',
                                getFirstIndexData?.id
                              )
                            ">
                  {{ "MANAGEUSER.VIEWLICENSE" | translate }}
                </button></span>
              <span btn3><button *ngIf="!loggedInUser" type="button" class="q-form-white-submit"
                  (click)="checkUserBeforeDeleting(getFirstIndexData)">
                  {{ "MANAGEUSER.DELETEUSER" | translate }}
                </button>
              </span>
            </div>
            <div *ngIf="selectedIndex && getFirstIndexData">
              <span btn1 *ngIf="getFirstIndexData?.assignedUserStatus !== 'ASSIGNED_USER_STATUS_PENDING'"><button
                  class="submit-btn bg-orgclr mb-2 me-3" (click)="isNavigate('viewDevice', getFirstIndexData?.id)">
                  {{ "MANAGEUSER.VIEWDEVICE" | translate }}
                </button></span>
              <span btn2 *ngIf="getFirstIndexData?.assignedUserStatus !== 'ASSIGNED_USER_STATUS_PENDING'"><button
                  class="q-form-white-submit mb-2 me-3" (click)="isNavigate('viewLicense', getFirstIndexData?.id)">
                  {{ "MANAGEUSER.VIEWLICENSE" | translate }}
                </button></span>
              <span btn3 *ngIf="getFirstIndexData?.assignedUserStatus !== 'ASSIGNED_USER_STATUS_PENDING'"><button
                  type="button" class="q-form-white-submit" (click)="checkUserBeforeDeleting(getFirstIndexData)">
                  {{ "MANAGEUSER.DELETEUSER" | translate }}
                </button></span>
              <span btn3 *ngIf="getFirstIndexData?.assignedUserStatus === 'ASSIGNED_USER_STATUS_PENDING'"><button
                  type="button" class="q-form-white-submit" (click)="openTempUserDeletePopup(getFirstIndexData)">
                  {{ "MANAGEUSER.DELETEUSER" | translate }}
                </button></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!enableGridView">
  <app-manage-users-tree-view></app-manage-users-tree-view>
</div>

<div class="modal" id="deleteUserPopup" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered ">
    <ng-container *ngIf="noDeviceFount">
      <div
        class="modal-content text-center border-none changeWidthHeight rounded-25 shadow-lg relative w-100 pointer-events-auto bg-white outline-none">
        <div class="mt-3">
          <img src="./assets/images/delete.svg" alt="" class="mx-auto" />
        </div>
        <h5 class="fw-bold mt-3 mb-2">
          {{ "MANAGEUSER.DELETEUSER" | translate }}?
        </h5>
        <p class="text-sm">
          {{ "MANAGEUSER.AREYOUSURETODELETE" | translate }} "{{
          getFirstIndexData.name
          }}"?
        </p>

        <ng-container *ngIf="deleteUserResponseMessage">
          <p>{{ deleteUserResponseMessage }}</p>
        </ng-container>
        <div class="d-flex justify-content-center text-center">
          <div class="me-3">
            <button class="submit-btn bg-orgclr" (click)="deleteAssignedUser(getFirstIndexData)">
              {{ "SUCESSMESSAGE.YES" | translate }}
            </button>
          </div>
          <div>
            <button type="button" class="cancel-btn bg-cancelbtn mb-4" data-bs-dismiss="modal">
              {{ "LOGIN.CANCEL" | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="deleteSuccess">
      <div
        class="modal-content text-center border-none px-4  rounded-25 shadow-lg relative w-100 pointer-events-auto bg-white outline-none">
        <div class="mt-4">
          <img src="./assets/images/SuccessIllustration.png" alt="" class="mx-auto" />
        </div>
        <h5 class="fw-bold mt-3 mb-2">
          {{ "SUCESSMESSAGE.UserDeleteSuccess" | translate }}
        </h5>
        <div class="text-center">
          <div class="q-tab-content-title">
            <button type="button" class="submit-btn bg-orgclr mt-4 mb-4 w-auto" data-bs-dismiss="modal">
              {{ "SIGNUP.DONE" | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- Add User Popup -->

<div class="modal mx-auto fade fixed top-0 left-0 w-100 h-100 outline-none overflow-y-auto" id="addUserPopup"
  data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel"
  aria-hidden="true">
  <ng-container *ngIf="showAddUserPopup == 'NO'">
    <div
      class="modal-dialog changeWidthHeight  relative pointer-events-none q-addDeviceModal adduserPopupNewDimensions modal-dialog-centered ">
      <div
        class="modal-content border-none changeWidthHeight py-1 paddingResponsivePopup rounded-25 shadow-lg relative d-flex flex-column w-100 pointer-events-auto outline-none">
        <div class="modal-body relative">
          <div class="mx-4 my-3">
            <h4 class="text-center">
              <app-main-heading>
                <span title> {{ "MANAGEUSER.ADDUSER" | translate }}</span>
              </app-main-heading>
            </h4>
          </div>
          <form [formGroup]="addUserForm">
            <div class="form-div">
              <div class="form-group mb-4 roleWidth">
                <label for="name" class="q-form-label">{{ "MANAGEUSER.NAME" | translate
                  }}<span class="text-danger">*</span></label>
                <input type="text" #testInput autocomplete="off" minlength="3" maxlength="50" (keypress)="
                    keyPressAlphaNumericWithCharacters($event, 'name')
                  " (keydown)="removeSpace($event, 'name')" (keydown)="onlyAlphabets($event)"
                  class="q-form-control outlineNone w-100 px-3" formControlName="name"
                  placeholder="{{ 'MANAGEUSER.PLEASEENTERNAME' | translate }}" />
              </div>
              <div class="form-group mb-4 roleWidth">
                <label class="q-form-label tooltips">{{ "MANAGEUSER.ROLES" | translate
                  }}<span class="text-danger">*</span></label>
                <div class="dropdown info-dropdown cursor-pointer">
                  <img src="assets/images/information.svg" alt="" class="ms-2" />
                  <div class="dropdown-content">
                    <div class="d-flex flex-column">

                      <div><STRONG>{{ "MANAGEUSER.ROLESADDNOTES.SUPERADMIN" | translate }}
                        </STRONG>
                        {{ "MANAGEUSER.ROLESADDNOTES.SUPERADMINNOTE" | translate }} </div>
                      <div> <STRONG>{{ "MANAGEUSER.ROLESADDNOTES.ADMIN" | translate }}
                        </STRONG> {{ "MANAGEUSER.ROLESADDNOTES.ADMINNOTE" | translate }}</div>
                      <div><STRONG>{{ "MANAGEUSER.ROLESADDNOTES.MEMBER" | translate }}
                        </STRONG> {{ "MANAGEUSER.ROLESADDNOTES.MEMBERNOTE" | translate }}</div>
                      <div><STRONG>{{ "MANAGEUSER.ROLESADDNOTES.CHILD" | translate }}
                        </STRONG> {{ "MANAGEUSER.ROLESADDNOTES.CHILDNOTE" | translate }}</div>
                    </div>
                  </div>
                </div>
                <div class="d-flex relative  cursor-pointer">
                  <select id='selectUserType' (change)="isSentOTP?verifyAgain('role'):''" formControlName="role"
                    class="bg-white outlineNone border w-100 q-form-control h-45 py-2 form-select transferSelect cursor-pointer addUserSelected">
                    <option selected disabled value='null'>
                      {{ "MANAGEUSER.SELECTROLE" | translate }}
                    </option>
                    <option [hidden]="loggedInUser.roleType == CommonEnum.ADMIN" [value]="CommonEnum.ADMIN">
                      {{ "MANAGEUSER.ADMIN" | translate }}
                    </option>
                    <option [value]="CommonEnum.MEMBERS">
                      {{ "MANAGEUSER.MEMBER" | translate }}
                    </option>
                    <option [value]="CommonEnum.CHILD">
                      {{ "MANAGEUSER.CHILD" | translate }}
                    </option>

                  </select>
                  <img src="../../../assets/images/faq-dropdown.svg" alt="" class="down-chevron-dropdown">
                </div>
              </div>
              <div class="form-group mb-4 w-100">
                <label for="email" class="q-form-label">{{"ADDDEVICE.EMAIL" | translate}} <span
                    class="text-danger">*</span></label>
                <div class="d-flex w-100 justify-content-between align-items-center">
                  <div class="w-75 d-flex relative">
                    <input type="email" id="emailField" [readonly]="isVerified" autocomplete="off"
                      class="w-100 q-form-control outlineNone px-3"
                      placeholder="{{'MANAGEUSER.PLEASEENTEREMAIL' | translate }}" minlength="8" maxlength="100"
                      formControlName="email" (keydown)="removeSpace($event, 'email')" (keypress)="
                        keyPressAlphaNumericWithCharacters($event, 'email')
                      " />
                    <img src="/assets/images/Green Tick.svg" *ngIf="isVerified" alt="" class="doneImgEmail">
                    <img src="/assets/images/pen.svg" alt="" *ngIf="isVerified" class="doneImgEmailPENCIL"
                      (click)="verifyAgain('email')">
                  </div>
                  <ng-container class="w-25"
                    *ngIf="this.addUserForm.controls['role'].value == CommonEnum.CHILD && !this.isSentOTP">
                    <button type="button" [ngClass]="this.addUserForm.valid?'otp-btn w-25':'otp-invalid-btn w-25'"
                      (click)="emailOTP()" [disabled]="addUserForm.invalid"
                      [style.width]="selectedLanguage === 'ja' ? '42px' : null"
                      [style.fontSize]="selectedLanguage === 'ja' ? '14px !important' : null">>{{"MANAGEUSER.SENDOTP" |
                      translate}}</button>
                  </ng-container>


                  <!-- otp timer -->

                  <ng-container class="w-25" *ngIf="isSentOTP && timeOver && isVerified!=true">
                    <div class="d-flex align-items-center  justify-content-center">
                      <small class="reponsiveForMobilesCount textColorGreenVogue">{{ "RESENDOT.RESENDOTPIN" | translate
                        }} {{ durationMinutes }}</small>
                    </div>
                  </ng-container>
                  <div class="mb-4 w-25 d-flex align-items-center  justify-content-center"
                    *ngIf="!timeOver && isSentOTP && isVerified!=true">

                    <button type="button" style="cursor: pointer; height: 0px !important " [ngClass]="
                        addUserForm.controls['email'].invalid && timeOver
                              ? 'border-0 bg-white resend-Otp cursor-pointer shadow-none outline-none p-0 ms-2 textResponsive cursor-not-allowed'
                              : 'border-0 bg-white resend-Otp cursor-pointer shadow-none outline-none p-0 ms-2 textResponsive'
                          " [disabled]="addUserForm.controls['email'].invalid" (click)="emailOTP()">
                      {{ "MANAGEUSER.RESENDOTP" | translate }}
                    </button>
                  </div>
                </div>

                <!-- otp -->

                <ng-container *ngIf="isSentOTP">
                  <label class="mt-3  q-form-label">{{ "MANAGEUSER.OTP" | translate
                    }}<span class="text-danger">*</span></label>
                  <div class="d-flex flex-wrap align-items-center creatingGap reponsiveForMobile">
                    <div class="charClass letterSpacing">
                      {{ emailResponseOTP }}
                    </div>
                    <div>
                      <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="config"></ng-otp-input>
                    </div>
                    <div>
                      <button type="button" class="q-form-white-submit" (click)="verifyOtp()"
                        [ngClass]="otpValue? 'q-otp-white-submit mb-0 cursor-not-allowed': 'q-otp-white-submit mb-0'">
                        {{"MANAGEUSER.VERIFY" | translate}}
                      </button>
                    </div>
                  </div>

                </ng-container>

                <!-- otp resend -->



                <!-- otp -->
              </div>
              <ng-container *ngIf="forgotPasswordErrorMessage!='' && isVerified==false && isSentOTP==true && timeOver">
                <p class="errMessage">{{ forgotPasswordErrorMessage }}</p>
              </ng-container>
              <ng-container *ngIf="addUserErrorMessage && this.addUserForm.invalid">
                <p class="errMessage">{{ addUserErrorMessage }}</p>
              </ng-container>

              <div class="mt-4 d-flex">
                <div>

                  <button (click)="onAddUser($event)"
                    [disabled]="isVerified ==false && this.addUserForm.controls['role'].value == CommonEnum.CHILD||this.addUserForm.controls['name'].value ==null||this.addUserForm.controls['email'].value ==null||this.addUserForm.controls['name'].value ==''||this.addUserForm.controls['email'].value ==''"
                    [ngClass]="
                      isVerified ==false && this.addUserForm.controls['role'].value == CommonEnum.CHILD||this.addUserForm.controls['name'].value ==null||this.addUserForm.controls['email'].value ==null||this.addUserForm.controls['name'].value ==''||this.addUserForm.controls['email'].value ==''
                        ? 'q-addUser-invalid-button w-100'
                        : 'submit-btn bg-orgclr  w-100 '
                    ">
                    {{ "MANAGEUSER.ADD" | translate }}
                  </button>
                </div>
                <div class="mx-3">
                  <button type="button" class="cancel-btn bg-cancelbtn w-100" (click)="closeAddUserModal()">
                    {{ "LOGIN.CANCEL" | translate }}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="showAddUserPopup=='YES'">
    <div class="modal-dialog relative w-auto pointer-events-none modal-dialog-centered">
      <div
        class="modal-content px-4 border-none shadow-lg relative text-center rounded-25 w-100 pointer-events-auto bg-white outline-none transferowneshipwidth">
        <div class="mt-4">
          <img src="./assets/images/SuccessIllustration.png" alt="" class="mx-auto" />
        </div>
        <h5 class="fw-bold mt-4">
          {{ "SUCESSMESSAGE.INVITSUCCESS" | translate }}
        </h5>
        <span class="text-xs">{{ "SUCESSMESSAGE.EMAILINVITE" | translate }}
          {{ emailSentUserName }}</span>
        <div class="text-center">
          <div class="q-tab-content-title">
            <button type="button" class="submit-btn bg-orgclr w-auto mt-4 mb-4" data-bs-dismiss="modal">
              {{ "SIGNUP.DONE" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="showAddUserPopup=='CHILD'">
    <div class="modal-dialog relative w-auto pointer-events-none modal-dialog-centered">
      <div
        class="modal-content px-4 border-none shadow-lg relative text-center rounded-25 w-100 pointer-events-auto bg-white outline-none">
        <div class="mt-4">
          <img src="./assets/images/SuccessIllustration.png" alt="" class="mx-auto" />
        </div>
        <h5 class="fw-bold mt-4">
          {{ "SUCESSMESSAGE.CHILD_ADDED_SUCCESS" | translate }}
        </h5>
        <div class="text-center">
          <div class="q-tab-content-title">
            <button type="button" class="submit-btn bg-orgclr w-auto mt-4 mb-4" data-bs-dismiss="modal">
              {{ "SIGNUP.DONE" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<!-- Reshare Link Popup -->
<div class="modal mx-auto fade fixed top-0 left-0 w-100 h-100 outline-none overflow-y-auto" id="reshareLinkModal"
  data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel"
  aria-hidden="true">
  <div class="modal-dialog relative w-auto pointer-events-none modal-dialog-centered">
    <div
      class="modal-content px-4 border-none shadow-lg relative text-center rounded-25 w-100 pointer-events-auto bg-white outline-none">
      <div class="mt-4">
        <img src="./assets/images/SuccessIllustration.png" alt="" class="mx-auto" />
      </div>
      <h5 class="fw-bold mt-4">
        {{ "SUCESSMESSAGE.INVITSUCCESS" | translate }}
      </h5>
      <span class="text-xs">{{ "SUCESSMESSAGE.EMAILINVITE" | translate }}
        {{ emailSentUserName }}</span>
      <div class="text-center">
        <div class="q-tab-content-title">
          <button type="button" class="submit-btn bg-orgclr w-auto mt-4 mb-4" (click)="closeInviteModal('reshareUser')">
            {{ "SIGNUP.DONE" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Before Transfer ownership -->

<div class="modal" id="transferOwnerShipBefore" data-bs-backdrop="static">
  <div class="modal-dialog transferowneshipwidth modal-dialog-centered">
    <div class="modal-dialog transferowneshipwidth relative w-100 pointer-events-none">
      <div
        class="modal-content border-none shadow-lg p-4 rounded-25 relative w-100 pointer-events-auto bg-white outline-none ">
        <div class="text-center align-items-center">
          <div class="modal-header-ownership">
            {{ "MANAGEUSER.TRANSFEROWNERSHIP" | translate}}
          </div>
          <div class="">
            <img src="./assets/images/transferOwner.svg" alt="" class="mx-auto" />
          </div>
          <div class="modal-ownership-desc mt-3">
            {{"MANAGEUSER.OWNERSHIPMODALDESC" | translate}}
          </div>
          <div class="modal-ownership-desc">
            {{ "MANAGEUSER.OWNERMODALLINE2" | translate }}
          </div>
          <!-- <h5 class="q-modal-heading fw-bold my-4 deleteUser">
            {{ "MANAGEUSER.DELETEUSERTRANSFER" | translate }}
          </h5> -->
          <div class="d-flex justify-content-center align-items-center mt-4" *ngIf="modalForEng">
            <div class="me-3">
              <button type="button" class="q-form-white-submit mb-2 me-2" style="width: 120px;" data-bs-dismiss="modal">
                {{ "LOGIN.CANCEL" | translate }}
              </button>
            </div>
            <!-- <div>
              <button type="button" class="cancel-btn bg" data-bs-dismiss="modal">
                {{ "LOGIN.CANCEL" | translate }}
              </button>
            </div> -->
            <div class="">
              <button class="submit-btn bg-orgclr" (click)="openTransferOwnershipModal()">
                {{ "MANAGEDEVICE.TRANSFEROWNERSHIP" | translate }}
              </button>
            </div>
          </div>
          <div class="w-100 flex-nowrap align-items-center d-none d-md-block mw-400 mx-auto mt-4" style="float:right;"
            *ngIf="!modalForEng">
            <button type="button" class="q-form-white-submit mb-2 me-3" style="width: 120px;" data-bs-dismiss="modal">
              {{ "LOGIN.CANCEL" | translate }}
            </button>
            <button class="submit-btn bg-orgclr" style="padding-left: 22px;padding-right: 22px;"
              (click)="openTransferOwnershipModal()">
              {{ "MANAGEDEVICE.TRANSFEROWNERSHIP" | translate }}
            </button>
          </div>
          <div class="w-100 flex-nowrap align-items-center d-block d-md-none mw-400 mx-auto mt-4" *ngIf="!modalForEng">
            <button class="submit-btn bg-orgclr" style="padding-left: 22px;padding-right: 22px;"
              (click)="openTransferOwnershipModal()">
              {{ "MANAGEDEVICE.TRANSFEROWNERSHIP" | translate }}
            </button>
            <div class="w-100 d-block d-md-none">
              <button type="button" class="q-form-white-submit w-100 mt-2" data-bs-dismiss="modal">
                {{ "LOGIN.CANCEL" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Transfer Ownership after confirmation -->
<div class="modal" id="transferOwnerShipAfterConfirmation" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered">
    <div
      class="modal-content border-none shadow-lg p-4 rounded-25 relative w-100 pointer-events-auto bg-white outline-none">
      <ng-container *ngIf="isOwnership">
        <div class="text-center mb-3">
          <h5 class="mb-0">
            <app-main-heading>
              <span title>{{
                "MANAGEDEVICE.TRANSFEROWNERSHIP" | translate
                }}</span>
            </app-main-heading>
          </h5>
        </div>
        <form [formGroup]="transferOwnershipForm" (ngSubmit)="onTransferOwnership()">
          <div class="form-div ">
            <div class="row">
              <label for="" class="q-form-label">{{"MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.CURRENTUSER" | translate}}
              </label>
              <p class="q-form-control mb-0 form-control py-0 border-0">
                <strong>{{ getFirstIndexData?.name }}</strong>
              </p>
            </div>
            <div>
              <label for="" class="q-form-label">{{
                "MANAGEUSER.DEVIEDETAILS" | translate
                }}</label>
              <div class="table-responsive mb-3">
                <table class="table mb-0 activity-table" aria-describedby="User Details">
                  <thead class="activity-header">
                    <tr>
                      <th>
                        <div class="">
                          <input type="checkbox" id="option_checkbox" [checked]="allChecked" (change)="
                              onDeviceClick(
                                $event,
                                getUserDeviceData,
                                'multiple'
                              )
                            " class="align-middle" />
                        </div>
                      </th>
                      <th class="text-sm">
                        {{ "MANAGEUSER.DEVICENAME" | translate }}
                      </th>
                      <th class="text-sm">
                        {{ "MANAGEUSER.DEVICETYPE" | translate }}
                      </th>
                      <th class="text-sm">
                        {{ "MANAGEUSER.PRODUCTKEY" | translate }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="
                        let item of getUserDeviceData;
                        let i = index;
                        trackBy: trackByFn
                      " class="text-capitalize bg-white">
                      <td>
                        <div class="">
                          <input type="checkbox" id="option_checkbox" [checked]="individualChecked"
                            (change)="onDeviceClick($event, item, 'single')" name="ritem" class="align-middle" />
                          <label for="ritema"></label>
                        </div>
                      </td>
                      <td>
                        {{ item.deviceName | translate }}
                      </td>
                      <td>
                        {{ item.deviceType | translate }}
                      </td>
                      <td>
                        {{ item.productKey | translate }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <select name="" id="target" class="form-select shadow-none"
                  (ngModelChange)="transferOwnershipUsername($event)" formControlName="assignedUserId">
                  <option selected disabled value="undefined">
                    {{"PARENTALREPORTS.SELECTUSER" | translate}}
                  </option>
                  <option [value]="loggedInUser.id">
                    {{ "MANAGEUSER.SELF" | translate }} ({{
                    loggedInUser.roleTypeStr
                    }})
                  </option>
                  <option *ngFor="let item of getTransferOwnershipUser" [hidden]="getFirstIndexData.id == item.id"
                    [value]="item.id">
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="text-center">
              <div class="d-flex mt-3">
                <div class="me-3">
                  <button type="submit" class="submit-btn bg-orgclr" [ngClass]="
                      transferOwnershipForm.invalid || deviceIdList.size == 0
                        ? 'q-invalid-button '
                        : 'submit-btn bg-orgclr '
                    " [disabled]="
                      transferOwnershipForm.invalid || deviceIdList.size == 0
                    ">
                    {{ "SUCESSMESSAGE.YES" | translate }}
                  </button>
                </div>
                <div>
                  <button type="button" class="cancel-btn bg-cancelbtn px-4" (click)="closeModaltransfer()">
                    {{ "SUCESSMESSAGE.NO" | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </ng-container>
      <ng-container *ngIf="isTransferOwnershipSuccess">
        <div class="">
          <div class="text-center">
            <div>
              <img src="./assets/images/SuccessIllustration.png" alt="" class="mx-auto" />
            </div>
            <h5 class="q-modal-heading fw-bold mt-4">
              {{
              "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.OWNERSHIPTRANSFERSUCCESS"
              | translate
              }}
            </h5>
            <p class="text-xs">
              {{
              "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.DEVICEOWNERSHIPTO"
              | translate
              }}
              {{ getUser }}
              {{
              "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.SUCCESSFULLY" | translate
              }}.
            </p>
            <button class="w-25 submit-btn bg-orgclr" (click)="closeTransferSuccess()">
              {{ "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.DONE" | translate }}
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>